import React, { Component, Fragment } from "react";

import { MODAL_TYPES } from "../../constants/modals";
import SigninForm from "../../containers/SigninForm";

class SigninModal extends Component {
  constructor(props) {
    super(props);

    this.handleSignup = this.handleSignup.bind(this);
  }

  handleSignup() {
    this.props.openModal({ modalType: MODAL_TYPES.SIGNUP });
  }

  render() {
    return (
      <Fragment>
        <div className="modal__header">
          <span>{this.props.t("signin:connect")}</span>
        </div>

        <div className="modal__body">
          <div className="modal__close" onClick={this.props.handleCloseModal}>
            <svg className="bars-icon" viewBox="0 0 24 24">
              <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
            </svg>
          </div>

          <div className="signin-modal">
            <div className="signin-modal__description">
              <div dangerouslySetInnerHTML={{ __html: this.props.t("signin:introPage") }} />
            </div>
            <div className="signin-modal__content">
              <div className="signin-modal__left">
                <SigninForm
                  t={this.props.t}
                  openPasswordResetModal={this.props.openPasswordResetModal}
                />
              </div>
              <div className="signin-modal__right">
                <div className="pb2 f4 font-bold">{this.props.t("signin:noaccount")}</div>
                <button className="button" onClick={this.handleSignup}>
                  {this.props.t("signin:inscriptionButton")}&nbsp;<i className="i-arrow-right f7" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default SigninModal;



// WEBPACK FOOTER //
// ./src/components/modals/SigninModal.js